import r from "./underscore.js";
import t from "./each.js";
import o from "./functions.js";
import { push as p } from "./_setup.js";
import i from "./_chainResult.js";
function n(n) {
  return t(o(n), function (t) {
    var o = r[t] = n[t];
    r.prototype[t] = function () {
      var t = [this._wrapped];
      return p.apply(t, arguments), i(this, o.apply(r, t));
    };
  }), r;
}
export { n as default };